import { ChangeEvent } from "react";
import React, { FC, useState, useEffect, memo, useMemo } from "../../../../lib/teact/teact";
import ReportApi from "../../restapi/reportApi";
import LotSelect from "../../ui/lotSelect";
import { MessageReport } from "../../db/report/totalReport";
import TotalReportByMessage from "../Report/totalReportByMessage";
import { ApiResult } from "../../db/report/localBackend";
import { ITotalreportAll, TotalreportAllImpl } from "../../db/report/totalreportAllType";
import './totalreportAll.scss'
import ListItem from "../../../ui/ListItem";
import { tienFormat } from "../../utils/NumberUtils";
import Button from "../../../ui/Button";
import Modal from "../../../ui/Modal";
import { copyTextToClipboard } from "../../../../util/clipboard";
import worker from "../../setupWorker";
import _ from 'lodash'
import { SendTeleMessage } from "../../tdlib/tdlib";
import { globalDexieDb } from "../../db/DexiedbLib";
import { selectChat, selectUser } from "../../../../global/selectors";
import { getActions, getGlobal } from "../../../../global";
import { isLocalMode } from "../../utils/common";
type OwnProps = {
    reportTotalAllData: ApiResult;

}

const TotalReportAll: FC<OwnProps> = ({
    reportTotalAllData,


}) => {
    const {
        sendMessage,
        //selectUser,//selectUser(global, userId);
    } = getActions()
    const [state, setState] = useState({
        data: reportTotalAllData, //map, key=contactId, value=report
        showSendMessageModal: false,
        textToSend: "",
        curContactId: 0,
    })

    const reports: TotalreportAllImpl[] = reportTotalAllData.data;
    const handleCardClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        console.log('card clicked', e);
    };
    let totalLaiLo = 0;
    function getTextTotalLaiLo(totalLaiLo: number): string {
        let result = ''
        if (totalLaiLo > 0)
            result = ` lãi ${tienFormat(totalLaiLo)}`
        else if (totalLaiLo < 0) {
            result = ` lỗ ${tienFormat(totalLaiLo)}`
        } else {
            result = ` hoà`
        }
        return result;
    }
    function onModalClose() {
        setState(prev => ({ ...prev, showSendMessageModal: false }))
    }
    function sendTeleMessage(contactId: number) {
        globalDexieDb.contacts.where('contactId').equals(contactId).first().then(ct => {
            if (ct) {
                const global = getGlobal()
                let user = selectUser(global, `${ct.tlUserId}`)
                let chat = selectChat(global, `${ct.tlUserId}`)
                let title = `${ct.tlUserId}`
                if (chat) {
                    title = chat.title
                }
                if (user || chat) {
                    const ok = SendTeleMessage(state.textToSend, `${ct.tlUserId}`, sendMessage)
                    if (ok) {
                        const payload = { type: 'showsnackbar', data: `Đã gửi tin tele tới ${title}` }
                        worker.postMessage(payload)
                    }
                } else {
                    const payload = { type: 'showsnackbar', data: `Không tìm thấy người nhận ${title}` }
                    worker.postMessage(payload)
                    // const ok = SendTeleMessage(state.textToSend, `${ct.tlUserId}`, sendMessage)
                    // if (ok) {
                    //     const payload = { type: 'showsnackbar', data: `Đã gửi tin tele tới ${title}` }
                    //     worker.postMessage(payload)
                    // }
                }
            }
        })

    }
    return (
        <>
            {reports && reports.map((msgInput: TotalreportAllImpl, index: number) => {
                const ret: any[] = []
                let msg: TotalreportAllImpl = msgInput
                if (!isLocalMode()) {
                    msg = new TotalreportAllImpl();
                    msg.nhanVe = _.cloneDeep(msgInput.nhanVe)
                    msg.chuyenDi = _.cloneDeep(msgInput.chuyenDi)
                    msg.contactId = msgInput.contactId
                    msg.contactName = msgInput.contactName
                }
                if (msg.nhanVe != null)
                    ret.push(

                        <TotalReportByMessage data={msg.nhanVe} key={'nhan:' + index}
                            onChangeViewType={() => { }}
                            messageIndex={0}
                            onRemoveItem={() => { }}
                            onReloadItem={() => { }}
                            hideToolbar
                             
                        />)
                if (msg.chuyenDi != null)
                    ret.push(

                        <TotalReportByMessage data={msg.chuyenDi} key={'chuyen:' + index}
                            onChangeViewType={() => { }}
                            messageIndex={0}
                            onRemoveItem={() => { }}
                            onReloadItem={() => { }}
                            hideToolbar
                        />)


                const contactLaiLo = msg.getLaiLoTotal()
                totalLaiLo += contactLaiLo;
                let thuBu = '';
                if (contactLaiLo > 0)
                    thuBu = 'thu'
                else if (contactLaiLo < 0) {
                    thuBu = 'bù'
                } else {
                    thuBu = 'hoà'
                }
                const tmp = ` ${thuBu}:${tienFormat(contactLaiLo)}`
                ret.push(<div
                    className={contactLaiLo > 0 ? "total-report-by-contact-total-row thu" : "total-report-by-contact-total-row bu"}>
                    <div>{msg.contactName}</div>
                    <div className="total-report-by-contact-total-money">{tmp}</div>
                    <div>
                        <Button round
                            size="tiny"
                            onClick={async () => {
                                const sms = await msg.getSMSCongNo()
                                setState(prev => ({
                                    ...prev, textToSend: sms, showSendMessageModal: true,
                                    curContactId: msg.contactId
                                }))
                            }}
                        >
                            <i className="icon icon-send"></i>
                        </Button>
                    </div>
                </div>)

                return <div className=" total-report-card-container" key={'wraper:' + index}>

                    {ret}</div>;
            })}
            <div
                className={totalLaiLo > 0 ? "total-report-by-contact-total-row thu" : "total-report-by-contact-total-row bu"}>
                <div>Tổng bảng</div>
                <div className="total-report-by-contact-total-money">{getTextTotalLaiLo(totalLaiLo)}</div>

            </div>
            <Modal onClose={onModalClose}
                isOpen={state.showSendMessageModal}
            >
                <div className=" common-padding">
                    <div className="editable-div" style="font-size:0.875rem; width:auto;">
                        {state.textToSend}
                    </div>
                    <div className=" common-container-row right-panel">
                        <Button size="tiny" round
                            onClick={() => {
                                if (navigator.share) {
                                    let text = state.textToSend
                                    navigator.share({
                                        title: 'Công nợ',
                                        text: text,
                                    })
                                } else {
                                    const payload = { type: 'showsnackbar', data: 'Trình duyệt của bạn không hỗ trợ tính năng chia sẻ' }
                                    worker.postMessage(payload)
                                }
                            }}
                        >
                            <i className=" icon icon-forward"></i>
                        </Button>
                        <Button size="tiny" round
                            onClick={() => {
                                copyTextToClipboard(state.textToSend)
                                const payload = { type: 'showsnackbar', data: 'đã copy tin nhắn vào bộ nhớ' }
                                worker.postMessage(payload)
                            }}
                        >
                            <i className=" icon icon-copy"></i>
                        </Button>
                        <Button size="tiny" round
                            onClick={() => sendTeleMessage(state.curContactId)}
                        >
                            <i className=" icon icon-send"></i>
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default memo(TotalReportAll);
